import React, { useState, useEffect, useRef } from 'react';
import './CustomDatePicker.css';

export default function CustomDatePicker({ value, onChange }) {
  const [showCalendar, setShowCalendar] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showYearList, setShowYearList] = useState(false);
  const yearListRef = useRef(null);

  const monthNames = [
    '1月', '2月', '3月', '4月', '5月', '6月',
    '7月', '8月', '9月', '10月', '11月', '12月'
  ];

  const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();

  const renderCalendar = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = getDaysInMonth(year, month);
    const days = [];

    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`blank-${i}`} className="gray"></div>);
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const isToday =
        i === new Date().getDate() &&
        month === new Date().getMonth() &&
        year === new Date().getFullYear();
      days.push(
        <div
          key={i}
          className={isToday ? 'today' : ''}
          onClick={() => {
            const selectedDate = new Date(year, month, i);
            const formattedDate = selectedDate.toLocaleDateString('sv-SE');
            onChange(formattedDate);
            setShowCalendar(false);
            setShowYearList(false);
          }}
        >
          {i}
        </div>
      );
    }
    return days;
  };

  const handlePrev = () => {
    setCurrentDate((prev) => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
  };

  const handleNext = () => {
    setCurrentDate((prev) => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));
  };

  useEffect(() => {
    function handleClickOutside(e) {
      if (!e.target.closest('.custom-datepicker')) {
        setShowCalendar(false);
        setShowYearList(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (showYearList && yearListRef.current) {
      const scrollToIndex = 50; // 現在年を中央に
      const itemHeight = 36;    // 年リストの1項目の高さ
      yearListRef.current.scrollTop = scrollToIndex * itemHeight - 100;
    }
  }, [showYearList]);

  return (
    <div className="custom-datepicker">
      <input
        type="text"
        value={value}
        readOnly
        onClick={() => {
          setShowCalendar(!showCalendar);
          setShowYearList(false);
        }}
        placeholder="生年月日を選択"
      />
      {showCalendar && (
        <div className="calendar-popup">
          <div className="setting-calendar-header">
            <span className="arrow prev" onClick={handlePrev}>&lt;</span>
            <span
              className="month"
              onClick={() => setShowYearList(!showYearList)}
              style={{ cursor: 'pointer' }}
            >
              {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
            </span>
            <span className="arrow next" onClick={handleNext}>&gt;</span>
          </div>

          {showYearList ? (
            <div className="year-scroll" ref={yearListRef}>
              {[...Array(100)].map((_, i) => {
                const year = new Date().getFullYear() - 50 + i;
                return (
                  <div
                    key={year}
                    className={`year-option ${year === currentDate.getFullYear() ? 'selected' : ''}`}
                    onClick={() => {
                      setCurrentDate(new Date(year, currentDate.getMonth(), 1));
                      setShowYearList(false);
                    }}
                  >
                    {year}
                  </div>
                );
              })}
            </div>
          ) : (
            <>
              <div className="calendar-days">
                <div>日</div><div>月</div><div>火</div><div>水</div><div>木</div><div>金</div><div>土</div>
              </div>
              <div className="calendar-dates">{renderCalendar()}</div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
